/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountUpdateRequest} from '../models/AccountUpdateRequest';
import type {Error} from '../models/Error';

export interface CreateAccount$Request {
    accountUpdateRequest: AccountUpdateRequest;
}

export interface CreateAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createAccountRequest = createAction<PayloadData<void, CreateAccount$Request>>('CREATE_ACCOUNT__CREATE_ACCOUNT__REQUEST');
export const createAccountSuccess = createAction<PayloadData<number, CreateAccount$Request>>('CREATE_ACCOUNT__CREATE_ACCOUNT__SUCCESS');
export const createAccountFailure = createAction<PayloadData<Error, CreateAccount$Request, true>>('CREATE_ACCOUNT__CREATE_ACCOUNT__FAILURE');

export const createAccountActions = [
    createAccountRequest,
    createAccountSuccess,
    createAccountFailure
] as const;

/**
 * @param {AccountUpdateRequest} meta.accountUpdateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createAccount = (meta: CreateAccount$Request, config?: CreateAccount$Config) => {
    return {
        CALL_API: {
            types: createAccountActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts`,
            TRANSPORT_REQUEST_BODY: meta.accountUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

